import type { Kenv } from 'kiswe-ui'

export enum TokenType {
  MetricsApi = 'MetricsApi'
}

export interface TokenCallableRequest {
  type: TokenType,
  kenv: Kenv|null
}

export interface TokenCallableResponse {
  token: string
}
